import { Card, withStyles } from '@material-ui/core';
import PrivacyIcon from '@material-ui/icons/Lock';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import qs from 'qs';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { AGREEMENT_DEFAULT_LINKS_GUEST, GREEN, ORANGE } from '../../_config/consts.js';
import { getLuckeyLogoSource } from '../../_config/utils';
import ExitIconCustom from '../../components/CustomIcons/ExitIconCustom.jsx';
import VisitorsIconCustom from '../../components/CustomIcons/VisitorsIconCustom.jsx';
import MDCheckBoxView from '../../components/forms/Fields/MDCheckBox/MDCheckBoxView.js';
import MDButton from '../../components/MDButton/MDButton.jsx';
import * as ModalsActions from '../../redux/actions/modal.actions';
import * as UserActions from '../../redux/actions/user.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';
import * as VisitorsActions from '../../redux/actions/visitors.actions.js';

const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: 20,
    backgroundColor: 'white',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 30,
    margin: 100,
    backgroundColor: 'white',
  },
  image: {
    height: 50,
    alignSelf: 'flex-start',
    marginBottom: 20,
  },
});

@withRouter
@connect(state => ({ userData: state.user.data, routing: state.router, companyConfigurations: state.user.companyConfigurations }))
class VisitorsActionsView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      visitorCode: null,
      visitDate: null,
      termsAccepted: false,
    };
  }

  async componentDidMount() {
    const { routing, dispatch } = this.props;
    const parsed = qs.parse(routing.location.search, { ignoreQueryPrefix: true });
    const code = parsed.code;
    const visitDate = parsed.visitDate;
    this.setState({ visitorCode: code, visitDate });
  }

  onShowCheckInConfirmation() {
    const { dispatch } = this.props;
    this.setState({ termsAccepted: false });
    const params = {
      modalType: 'CONTENT_MODAL',
      modalProps: {
        title: <Entity entity="privacyPolicy" />,
        hideHeader: false,
        content: this.renderPrivacyPolicyContent(),
        modalContainerStyle: { maxWidth: '100%', width: '100%', paddingBottom: 50 },
        onOutsideClick: () => dispatch(ModalsActions.hideModal()),
      },
    };
    dispatch(ModalsActions.showModal(params));
  }

  onTermsAcceptedChange = (value) => {
    this.setState({ termsAccepted: value }, () => {
      this.onShowCheckInConfirmation();
    });
  }

  onConfirmCheckIn = () => {
    const { dispatch } = this.props;
    dispatch(ModalsActions.hideModal());
    this.onCheckIn();
  }

  renderPrivacyPolicyContent() {
    const { termsAccepted } = this.state;
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        padding: '10px',
        maxHeight: '70vh',
      }}>
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row', 
          alignItems: 'center', 
          justifyContent: 'center', 
          marginBottom: 15 
        }}>
          <PrivacyIcon style={{ color: '#3f3f3f', marginRight: 10 }} />
          <h4 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold' }}>
            <Entity entity="readPrivacyPolicyBeforeCheckIn" />
          </h4>
        </div>
        <div style={{ 
          flex: 1, 
          overflow: 'auto', 
          border: '1px solid #e0e0e0', 
          borderRadius: 8,
          marginBottom: 20,
          minHeight: 300,
          maxHeight: '50vh',
        }}>
          <iframe 
            scrolling="yes" 
            style={{ 
              border: 'none', 
              width: '100%', 
              height: '100%',
              minHeight: 300,
            }} 
            src={AGREEMENT_DEFAULT_LINKS_GUEST.PRIVACY}
            title="Privacy Policy"
          />
        </div>
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          padding: '10px 0',
        }}>
          <MDCheckBoxView
            checked={termsAccepted}
            label={<Entity entity="acceptPrivacyPolicyTerms" />}
            titleStyle={{ fontSize: 14, fontWeight: 'bold', color: '#3f3f3f' }}
            onSelect={(value) => this.onTermsAcceptedChange(value)}
          />
          <MDButton
            title={<Entity entity="confirmCheckIn" />}
            backgroundColor={GREEN}
            disabled={!termsAccepted}
            containerStyle={{ marginTop: 15, marginBottom: 15, opacity: termsAccepted ? 1 : 0.5 }}
            onClick={() => this.onConfirmCheckIn()}
          />
        </div>
      </div>
    );
  }

  async onCheckIn() {
    const { dispatch } = this.props;
    const { visitorCode } = this.state;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(VisitorsActions.checkInVisitor(visitorCode));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalsActions.showModal({
        modalType: 'SUCCESS_MODAL',
        modalProps: {
          message: "checkInVisitorSuccess",
        },
      }))
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(ModalsActions.showModal({
          modalType: 'ERROR_MODAL',
          modalProps: {
            message: "checkInVisitorError",
          },
        }))
    }
  }

  async onCheckOut() {
    const { dispatch } = this.props;
    const { visitorCode } = this.state;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(VisitorsActions.checkOutVisitor(visitorCode));
      dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(ModalsActions.showModal({
          modalType: 'SUCCESS_MODAL',
          modalProps: {
            message: "checkoutVisitorSuccess",
          },
        }))
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(ModalsActions.showModal({
          modalType: 'ERROR_MODAL',
          modalProps: {
            message: "checkoutVisitorError",
          },
        }))
    }
  }

  onBackToLogin() {
    const { dispatch } = this.props;
    dispatch(UserActions.logout());
  }


  render() {
    const { visitorCode, visitDate } = this.state;
    const year = new Date().getFullYear();
    const luckeyLogoSource = getLuckeyLogoSource();
    return (
      <div id="auth-container" style={{ height: '100vh', overflow: 'scroll', display: 'flex', alignItems: 'center', backgroundColor: 'white', paddingTop: 30, flexDirection: 'column' }} className="login">
        <img src={luckeyLogoSource} alt="Sofia" style={{ margin: 10, marginTop: 20, marginBottom: 15, alignSelf: 'center', height: 65 }} />
        <div style={{ padding: 5, paddingTop: 0, paddingBottom: 0, marginBottom: 25, marginTop: 10 }}>
          <div>
            <h4 style={{ color: '#3f3f3f', fontWeight: 'bold', textAlign: 'center', marginBottom: 0, marginTop: 0 }}><Entity key={visitorCode} entity="visitDate" />{visitDate}</h4>
            <h4 style={{ color: '#3f3f3f', fontWeight: 'bold', textAlign: 'center', marginBottom: 0 }}><Entity key={visitorCode} entity="visitorCode" /></h4>
            <h1 style={{ color: '#3f3f3f', fontWeight: 'bold', textAlign: 'center', marginBottom: 0, marginTop: 5 }}>{visitorCode}</h1>
          </div>
          <div style={{ marginTop: 40, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <Card raised onClick={() => this.onShowCheckInConfirmation()} style={{ padding: 10, height: 180, width: 250, borderRadius: 10, marginBottom: 30, backgroundColor: GREEN, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <VisitorsIconCustom style={{ color: 'white', width: 35 }} />
              <h4 style={{ marginTop: 15, color: 'white', fontWeight: 'bold' }}><Entity entity="checkIn" /></h4>
              <h5 style={{ color: 'white', marginTop: 0, textAlign: 'center' }}><Entity entity="checkinVisitorExplanation" /></h5>
            </Card>
            <Card raised onClick={() => this.onCheckOut()}style={{ padding: 10, height: 180, width: 250, borderRadius: 10, backgroundColor: ORANGE, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <ExitIconCustom style={{ color: 'white', width: 35 }} />
              <h4 style={{ marginTop: 15, color: 'white', fontWeight: 'bold' }}><Entity entity="checkOut" /></h4>
              <h5 style={{ color: 'white', marginTop: 0, textAlign: 'center' }}><Entity entity="checkoutVisitorExplanation" /></h5>
            </Card>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 50 }}>
            <img src="/imgs/common/logoSofiaDark.png" alt="Sofia" style={{ height: 12, marginRight: 4 }} />
            <h6 style={{ fontSize: 10, margin: 0, marginTop: 3, color: '#3f3f3f' }}>©{year}</h6>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(VisitorsActionsView);
